export { Link } from './Link';
export type { ILinkProps } from './Link';
